var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form_box"},[_c('div',{staticClass:"form_box__header"},[_c('AppPageHeader')],1),_c('el-card',{staticClass:"box-card mt-2"},[_c('FXUserImport')],1),_c('el-card',{staticClass:"box-card mt-2"},[_c('p',[_vm._v("同步党组织信息")]),_c('FXPartyorgImport')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }